export enum NotificationType {
  SubscriptionExpiring = 'subscription-expiring',
  NylasInvalidGrant = 'nylas-invalid-grant',
}
